/* eslint-disable */
import { Form, Row, Col, Input, Select, Radio } from 'antd';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import { LOCAL, FEDERAL, AMBOS } from 'constants/ambitos';
import { PROCESOS_ESPECIFICOS, ESTADOS } from 'constants/nombresCatalogos';

import React, { useEffect } from 'react';

const DatosGenerales = ({ form }) => 
{
  const datosUser = useSelector((state) => state.validarUsuario.data);
  useEffect(() => 
  {
    try 
    {
      
    } catch (error) 
    {
      console.log('Error: ', error);
    }
  }, []);

  const procesosCat = useSelector(selectCatalogByName(PROCESOS_ESPECIFICOS));
  const entidades = useSelector(selectCatalogByName(ESTADOS));

  const procesos = procesosCat.map((proceso) => ({
    ...proceso,
    nombreProcesoEspecifico: proceso.nombreProcesoEspecifico.replace('Ã±', 'ñ')
  }));

  const handleClearBeneficiados = () => {
    // Al ser dependientes los beneficiarios del proceso hay que remover a los beneficiarios
    // al cambiar el proceso para evitar discrepancias
    // console.log('idProcesoEspecifico: ', form.getFieldsValue('idProcesoEspecifico'));
    form.setFieldsValue({
      beneficiados: [],
      tipoBeneficio: null,
      idProcesoEspecifico: form.getFieldsValue('idProcesoEspecifico').proceso
    });
  };

  return (
    <div>
      <Form form={form} layout="vertical">
        {' '}
        <Row>
          <Col span={3}>
            <Form.Item
              name="tipoEleccion"
              label="Tipo Elección:"
              rules={[{ required: true, message: '¡Campo obligatorio!' }]}>
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={1} />
          <Col span={3}>
            <Form.Item
              name="proceso"
              label="Proceso:"
              rules={[{ required: true, message: '¡Campo obligatorio!' }]}>
              <Select
                optionFilterProp="children"
                placeholder="Selecciona un proceso"
                options={procesos}
                fieldNames={{
                  value: 'idProcesoEspecifico',
                  label: 'nombreProcesoEspecifico'
                }}
                allowClear
                onChange={handleClearBeneficiados}
                disabled = { !datosUser.rol.includes('ADMIN') }
              />
            </Form.Item>
          </Col>
          <Col span={1} />
          <Col span={5}>
            <Form.Item
              name="ambito"
              label="Ámbito"
              rules={[{ required: true, message: 'El ambito es requerido' }]}
              onChange={handleClearBeneficiados}>
              <Radio.Group>
                <Radio value={FEDERAL}>Federal</Radio>
                <Radio value={LOCAL}>Local</Radio>
                <Radio value={AMBOS}>Ambos</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={1} />
          <Form.Item
            noStyle
            shouldUpdate={(prevProps, newProps) => {
              return prevProps.entidad !== newProps.entidad || prevProps.ambito !== newProps.ambito;
            }}>
            {() => {
              const { entidad, ambito } = form.getFieldsValue(['entidad', 'ambito']);
              const distritosLocales =
                entidades.find((e) => e.nombreEstado === entidad)?.distritosLocales || [];
              const distritosFederales =
                entidades.find((e) => e.nombreEstado === entidad)?.distritosFederales || [];
              distritosLocales.forEach((distritoLocal) => {
                // eslint-disable-next-line no-param-reassign
                distritoLocal.nombreConId = `${distritoLocal.idDistrito} - ${distritoLocal.cabeceraDistrital}`;
              });
              distritosFederales.forEach((distritoFederal) => {
                // eslint-disable-next-line no-param-reassign
                distritoFederal.nombreConId = `${distritoFederal.idDistrito} - ${distritoFederal.cabeceraDistrital}`;
              });
              return (
                <>
                  {(ambito === FEDERAL || ambito === AMBOS) && (
                    <Col xs={6}>
                      <Form.Item
                        name="distritoF"
                        label="Distrito Federal:"
                        rules={[{ required: true, message: 'El campo es requerido' }]}>
                        <Select
                          placeholder="Selecciona un distrito"
                          fieldNames={{
                            value: 'idDistrito',
                            label: 'nombreConId'
                          }}
                          options={distritosFederales}
                          filterOption={(inputValue, option) =>
                            option.nombreConId?.toUpperCase().indexOf(inputValue.toUpperCase()) !==
                            -1
                          }
                          showSearch
                        />
                      </Form.Item>
                    </Col>
                  )}
                  {(ambito === LOCAL || ambito === AMBOS) && (
                    <Col xs={6}>
                      <Form.Item
                        name="distrito"
                        label="Distrito Local:"
                        rules={[{ required: true, message: 'El campo es requerido' }]}>
                        <Select
                          placeholder="Selecciona un distrito"
                          fieldNames={{
                            value: 'idDistrito',
                            label: 'nombreConId'
                          }}
                          options={distritosLocales}
                          filterOption={(inputValue, option) =>
                            option.nombreConId?.toUpperCase().indexOf(inputValue.toUpperCase()) !==
                            -1
                          }
                          showSearch
                        />
                      </Form.Item>
                    </Col>
                  )}
                </>
              );
            }}
          </Form.Item>
        </Row>
      </Form>
    </div>
  );
};

DatosGenerales.propTypes = {
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func,
    getFieldsValue: PropTypes.func,
    validateFields: PropTypes.func
  }).isRequired
};

export default DatosGenerales;
